import React, { Component } from 'react';
import TimeAgo from 'react-timeago'
import { Link ,   Redirect} from 'react-router-dom'
  // router 
   
  



class Tuitons extends Component {

 
   constructor(props){
     super(props)
    //  this.onDelete = this.onDelete.bind(this);
    //  this.onEdit = this.onEdit.bind(this);
    //   this.editSubmit = this.editSubmit.bind(this)
     this.state = {
       isEdit:false,
       value : ""
     }
   }
  
   onDelete=()=>{
     const {onDelete , id} = this.props
    //  console.log("id", id)
     onDelete(id)
    
   }

submitedit=(event)=>{
  event.preventDefault(); 
  // console.log(" ------------ sedit", this.name.value, this.amount.value, this.description.value, this.id.value) 
   const data ={
     name:this.name.value,
     amount :this.amount.value,
     description : this.description.value,
     tuition_category_id : this.state.value,
     id : this.props.id,
     date : Date.now()
   }
  //  console.log("data category =====", data)
  this.props.submitedit(data)
  this.setState({isEdit:false})
}
  
showedit=()=>{
    //  console.log("-------")
     this.setState({isEdit:true})
 }
 
 close = ()=>{
  // console.log("-------")
  this.setState({isEdit:false})
 }
 alertClick=(event)=>{
  event.preventDefault();
  this.setState({ 
      alertDelete:true
   });  
}
closeOnDelete=( event)=>{
  event.preventDefault();
  this.setState({ 
      alertDelete:false
   });  
}

handlechangecategory=(event)=> {
  // console.log("category =========")
  this.setState({value: event.target.value});
  // console.log("category===============", this.state.value)
  
}


  
  render() {
    
    //console.log(this.props.name, "this.props.tuition_category_id", )
   
    //  const {title , author ,objectID} = this.props;

       
          if ( this.state.isEdit === false) {
            
             if( this.state.alertDelete  === true){
               return(

             <div className="notification-body-delete">
                                <div className="notification ">
                                        <button className="delete" onClick={this.closeOnDelete}></button>
                                        <strong>Are you sure to delete this item</strong><br/>
                                        <button className="button is-small  is-danger" onClick={this.onDelete}>delete</button>
                               </div>
                               
                             
               </div>)
             }else{
                return(
                     <li className="table-row">
                              <div className="col col-1" data-label="Job Id"> {this.props.data.name}</div>
                              <div className="col col-2" data-label="Customer Name">₦{this.props.data.amount}</div>
                              <div className="col col-3" data-label="Amount">
                              {
                                  this.props.data.type === "TK"?
                                  <p><i className="fas fa-tags">  </i>  Ticket   </p> 
                                  :
                                  <p><i className="fab fa-wpforms"></i>  Form </p>
                                }
                              </div>
                              <div className="col col-4" data-label="Payment Status">
                                {/* <button className="button is-small is-success " onClick={this.showedit}><i className="fas fa-edit"></i></button> */}
                                <button className="button is-small  is-danger my-event-link" onClick={this.alertClick}><i className="fas fa-times"></i></button>
                                {/* <Link   to={`/build/${this.props.id}`}  className="button is-success is-small"><i className="fas fa-money-bill-wave"></i></Link>
                                 <br/> */}
                                <Link   to={`/events/${this.props.id}`}  className="button is-success is-small my-event-link">
                                    <span className="icon is-small">
                                    <i className="far fa-eye "></i>
                                    </span>
                                    {/* <span>More view</span> */}
                                </Link>
                              </div>
                     </li> 
                ) 
             }
                    //  <li class="table-row">
                     
                    //           <div class="col col-1" data-label="Job Id">42235</div>
                    //           <div class="col col-2" data-label="Customer Name">John Doe</div>
                    //           <div class="col col-3" data-label="Amount">$350</div>
                    //           <div class="col col-4" data-label="Payment Status">Pending</div>
                      
                              
                    //    </li> 
                // <div className="table-cos">
                //    {
                //           this.state.alertDelete?
                //               <div className="notification-body-delete">
                //                 <div className="notification ">
                //                         <button className="delete" onClick={this.closeOnDelete}></button>
                //                         <strong>Are you sure to delete this item</strong><br/>
                //                         <button className="button is-small  is-danger" onClick={this.onDelete}>delete</button>
                //                 </div>
                               
                //             </div>
                //             :
                //             <div className="row" key={this.props.id}>
                             
                                  
                                
                //             </div>

                //         }
                        
                        
                //         <div className="hr-cos"></div>
                //     </div>
                 
               
               
            
          }else{
            return (
                
      

         
           <form  onSubmit={this.submitedit}>
               <div className="table-cos-from">
                        
                        <div className="row">
                          <div className="cell-form">  
                            <div className="control has-icons-left has-icons-right">
                                        <input className="input" type="text" ref={input => this.name = input} defaultValue={ this.props.name}  placeholder="Name of payment"   required/>  
                                          <span className="icon is-small is-left">
                                          <i className="fas fa-pen"></i>
                                         </span>  
                                </div> 
                              </div>
                             <div className="cell-form">
                                <div className="control has-icons-left has-icons-right">
                                        <input className="input" type="text" ref={input => this.amount = input} defaultValue={ this.props.amount} placeholder="Amount for payment"    required/>  
                                          <span className="icon is-small is-left">
                                          <i className="fas fa-hand-holding-usd"></i>
                                         </span>  
                                </div> 
                            </div>
                            
                            
                            <div className="cell-form2">
                                <div className="control has-icons-left has-icons-right">
                                        <input className="input" type="text" ref={input => this.description = input} defaultValue={ this.props.description} placeholder="More Information"  required/>  
                                          <span className="icon is-small is-left">
                                          <i className="far fa-question-circle"></i>
                                         </span>  
                                </div> 
                            </div>
                           
                            <input className="input" type="hidden" ref={input => this.id = input} defaultValue={ this.props.id} placeholder="More Information"  required/>  
                          
                            <div className="cell-form1">
                               <button className="button is-small is-success button-style" >Save</button>
                               <a className="button is-small is-link " onClick={this.close}>Close</a>
                            </div>
                           
                      </div>   
                         <br/>  
                         <div className="hr-cos"></div>   
                </div>
            </form>
      
          );
          }
          
        }

   
  


}

export default Tuitons;


// WEBPACK FOOTER //
// ./src/component/form/tuitions.js